function setupWebViewJavascriptBridge (callback) {
  if (window.WebViewJavascriptBridge) {
    return callback(window.WebViewJavascriptBridge)
  }
  if (window.WVJBCallbacks) {
    return window.WVJBCallbacks.push(callback)
  }
  window.WVJBCallbacks = [callback]
  const WVJBIframe = document.createElement('iframe')
  WVJBIframe.style.display = 'none'
  WVJBIframe.src = 'https://__bridge_loaded__'
  document.documentElement.appendChild(WVJBIframe)
  setTimeout(() => {
    document.documentElement.removeChild(WVJBIframe)
  }, 0)
}

function registerhandler (name, callback) {
  setupWebViewJavascriptBridge(function (bridge) {
    bridge.registerHandler(name, function (data, responseCallback) {
      callback(data, responseCallback)
    })
  })
}

function callhandler (name, data, callback) {
  setupWebViewJavascriptBridge(function (bridge) {
    bridge.callHandler(name, data, callback)
  })
}

function detect () {
  let equipmentType = ''
  const agent = navigator.userAgent.toLowerCase()
  const android = agent.indexOf('android')
  const iphone = agent.indexOf('iphone')
  const ipad = agent.indexOf('ipad')
  if (android !== -1) {
    equipmentType = 'android'
  }
  if (iphone !== -1 || ipad !== -1) {
    equipmentType = 'ios'
  }
  return equipmentType
}

export default {
  register (name, callbackObj) {
    const equipment = detect()
    if (equipment === 'ios') {
      registerhandler(name, callbackObj.ios?.callback)
    } else {
      window[name] = callbackObj.android
    }
  },
  callFn (name, callbackObj) {
    const equipment = detect()
    if (equipment === 'ios') {
      callhandler(name, callbackObj.ios.data, callbackObj.ios?.callback)
    } else {
      callbackObj.android(window.android[name]())
    }
  },
  sendData (fnName, data, callback) {
    const equipment = detect()
    if (equipment === 'ios') {
      callhandler(fnName, data, callback)
    } else {
      if (data) {
        let dataString = ''
        if (fnName === 'sendCouponId') {
          dataString = data.couponId
        } else if (fnName === 'setStatusColor') {
          dataString = data.color
        } else if (fnName === 'sendTakeMeth') {
          dataString = data.type
        } else if (fnName === 'getInvoiceUrl') {
          dataString = data.url
        } else {
          dataString = JSON.stringify(data)
        }
        callback ? callback(window.android[fnName](dataString)) : window.android[fnName](dataString)
      } else {
        callback ? callback(window.android[fnName]()) : window.android[fnName]()
      }
    }
  },
  close () {
    this.callFn('close', {
      ios: {
        data: null,
        callback: null
      },
      android: null
    })
  },
  detect
}
